import { render, staticRenderFns } from "./dealmakersDetails.vue?vue&type=template&id=2d108c66&scoped=true"
import script from "./dealmakersDetails.vue?vue&type=script&lang=js"
export * from "./dealmakersDetails.vue?vue&type=script&lang=js"
import style0 from "./dealmakersDetails.vue?vue&type=style&index=0&id=2d108c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d108c66",
  null
  
)

export default component.exports